import { render, staticRenderFns } from "./QuickPayResult.vue?vue&type=template&id=75d49a61&scoped=true"
import script from "./QuickPayResult.vue?vue&type=script&lang=js"
export * from "./QuickPayResult.vue?vue&type=script&lang=js"
import style0 from "./QuickPayResult.vue?vue&type=style&index=0&id=75d49a61&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "75d49a61",
  null
  
)

export default component.exports